import { toSnakeCase } from '@/common/utilities/stringUtilities.ts';

function appendFormData(
  form: FormData,
  data: Record<string, unknown>,
  namespace?: string
): void {
  for (const key of Object.keys(data)) {
    const value = data[key];
    const snakeKey = toSnakeCase(key);
    const formKey = namespace ? `${namespace}[${snakeKey}]` : snakeKey;

    if (value instanceof File) {
      form.append(formKey, value);
    } else if (value === null) {
      form.append(formKey, '');
    } else if (Array.isArray(value)) {
      if (value.length === 0) {
        form.append(`${formKey}[]`, '');
      } else {
        value.forEach((element) => {
          if (
            element !== null &&
            typeof element === 'object' &&
            !(element instanceof File)
          ) {
            appendFormData(
              form,
              element as Record<string, unknown>,
              `${formKey}[]`
            );
          } else {
            form.append(`${formKey}[]`, String(element));
          }
        });
      }
    } else if (
      typeof value === 'object' &&
      !(value instanceof Date) &&
      !(value instanceof File)
    ) {
      appendFormData(form, value as Record<string, unknown>, formKey);
    } else if (value !== undefined) {
      form.append(formKey, String(value));
    }
  }
}

export function objectToFormData(
  obj: Record<string, unknown>,
  namespace?: string
): FormData {
  const form = new FormData();
  appendFormData(form, obj, namespace);
  return form;
}
